import { Component, OnInit } from '@angular/core';
import { BaseSiteService, CmsBannerComponent,CmsService, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { UserInfoService } from '../../spartacus/services/user-info.service';

@Component({
    selector: 'app-having-trouble',
    templateUrl: './having-trouble.component.html',
    styleUrls: ['./having-trouble.component.scss'],
    standalone: false
})
export class HavingTroubleComponent implements OnInit{

firstnode: Observable<any> = this.bannerComponent.data$;
currentSite:string=''
currentPageUid = '';
constructor(private cmsService:CmsService, protected config: OccConfig,public bannerComponent: CmsComponentData<CmsBannerComponent>, private userInfoService:UserInfoService,private baseSiteService:BaseSiteService) {
   }

   ngOnInit(): void {
    this.baseSiteService.getActive().subscribe(site => {
      this.currentSite = site;
    });
    this.bannerComponent.data$.subscribe(data => {
      if (data && data.uid) {
        this.currentPageUid = data.uid;
      }
    });
  }
}
